// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1I4kS","ranges":"BmiRanges_ranges__3xsMR"};